import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'faq';

export const loadData = (params, search) => dispatch => {
  const pageAsset = { FAQPage: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
